import { useFormBaseMetadata, useModuleFederationContext } from '@msdk/common'
import {
  EntityContext,
  EntityMetadata,
  EntityModel,
  FormMode,
  FormModel,
  FormNode,
  shouldBeShownCustomUISubheader,
} from '@msdk/definitions'
import { css, styled, uiTokens } from '@msdk/ui'
import React from 'react'

import { resolveItem } from '../../utils'
import { ImportedComponentErrorBoundary } from '../ImportedComponentBoundary'

const FormSubheaderWrapper = styled('div', { shouldForwardProp: (props) => props !== '$isFullScreen' })<{
  $isFullScreen: boolean
}>`
  height: auto;
  width: 100%;
  padding: ${uiTokens.spacing.padding.medium}px 0 ${uiTokens.spacing.padding.small}px;
  ${({ $isFullScreen }) =>
    $isFullScreen &&
    css`
      max-width: 1024px;
    `}
`

interface Props {
  entity: EntityContext
  entityModel: EntityModel
  formModel: FormModel
  rootNode: FormNode
  mode: FormMode
  isFullScreen: boolean
  onModeChange: (newMode: FormMode, formName: string) => void
  onReloadEntity: () => Promise<void>
}

export function FormSubHeader(props: Props) {
  const baseMetadata = useFormBaseMetadata(props.entityModel.name, props.formModel.name) as EntityMetadata
  const modules = useModuleFederationContext()
  const msModule = modules.loadedModules[baseMetadata.msProvider]
  const ImportedComponent = resolveItem(msModule, props.formModel.subheader?.customUI)

  return (
    <>
      {shouldBeShownCustomUISubheader(props.mode, props.formModel) && ImportedComponent && (
        <ImportedComponentErrorBoundary>
          <FormSubheaderWrapper $isFullScreen={props.isFullScreen}>
            <ImportedComponent
              entityId={props.entity.id}
              entityModel={props.entityModel}
              formModel={props.formModel}
              mode={props.mode}
              onModeChange={props.onModeChange}
              reloadEntity={props.onReloadEntity}
            />
          </FormSubheaderWrapper>
        </ImportedComponentErrorBoundary>
      )}
    </>
  )
}
